module.exports = __webpack_public_path__ + "static/img/bg-globe-alpha.17ab0ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/page-home/sections/bg-globe-alpha.jpg
// module id = 828
// module chunks = 0